import { render, staticRenderFns } from "./BkashCallback.vue?vue&type=template&id=23a22189&scoped=true&"
import script from "./BkashCallback.vue?vue&type=script&lang=js&"
export * from "./BkashCallback.vue?vue&type=script&lang=js&"
import style0 from "./BkashCallback.vue?vue&type=style&index=0&id=23a22189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a22189",
  null
  
)

export default component.exports